import { DAY_TIME_ICON } from "@/common/helpers/get-day-time";
import { getFullUserName } from "@/common/helpers/get-full-user-name";
import { Card, CardContent } from "@/components/ui/card";
import { AvatarClickAction, UserAvatar } from "@/components/user-avatar/user-avatar";
import { userStore } from "@/store/user-store";
import { motion } from "framer-motion";
import { useGreeting } from "../_helpers/use-greeting";
import { WorldDotMap } from "./world-dot-map";

export function GreetingHero() {
  const user = userStore((state) => state.user);
  const fullName = user ? getFullUserName({ user }) : "";

  const { greeting, dayTime, formattedDate } = useGreeting();
  const DayTimeIcon = DAY_TIME_ICON[dayTime];

  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, ease: "easeInOut" }}
    >
      <Card className="overflow-hidden">
        <div
          aria-hidden
          className="from-primary/12 dark:from-primary/10 absolute inset-y-0 right-0 w-1/2 bg-linear-to-l to-transparent"
        />
        <WorldDotMap className="text-primary absolute -top-4 right-16 hidden h-[150%] mask-[linear-gradient(to_left,black,transparent)] opacity-40 md:block dark:opacity-25" />
        <CardContent className="relative flex items-center gap-4">
          <UserAvatar
            userAzureObjectUuid={user?.azureObjectUuid}
            name={fullName}
            className="size-14"
            clickAction={AvatarClickAction.None}
          />
          <div className="min-w-0 flex-1">
            <h1 className="truncate font-semibold tracking-tight sm:text-2xl">{greeting}</h1>
            <p className="text-muted-foreground mt-1 truncate text-sm capitalize sm:text-base">{formattedDate}</p>
          </div>
          <span className="bg-primary/10 text-primary flex h-11 w-11 shrink-0 items-center justify-center rounded-lg [&_svg]:h-6 [&_svg]:w-6">
            <DayTimeIcon />
          </span>
        </CardContent>
      </Card>
    </motion.div>
  );
}
